import { useState } from "react";
import { InputGroup } from "reactstrap";
import Autosuggest from 'react-autosuggest';
import { userGet } from "../../redux/utiles/apiUtillity";
import { withRouter } from "react-router-dom";

function HeaderSearch({ title, className, history }) {
    const [state, setState] = useState({
        value: '',
        suggestions: [],
        loading: false,
        enable: true
    });

    const getSuggestionValue = suggestion => suggestion;

    const renderSuggestion = suggestion => (
        <div>
            {suggestion}
        </div>
    );

    const onChange = (event, { newValue }) => {
        setState(prevState => {
            return {
                ...prevState,
                value: newValue
            }
        });
    };

    const onSuggestionsFetchRequested = async ({ value }) => {
        setState(prevState => {
            return {
                ...prevState,
                loading: true
            }
        });
        const { data, error } = await userGet(`search-suggest?query=${value}`);
        // console.log(data.data);
        if (!error) {
            setState(prevState => {
                return {
                    ...prevState,
                    suggestions: data.data,
                    loading: false
                }
            });
        } else {
            setState(prevState => {
                return {
                    ...prevState,
                    loading: false
                }
            });
        }
    };

    const doSearch = () => {
        // history.push(`/search/?query=${state.value}`);
        if (state.value !== "") {
            history.push(`/search/${state.value}`);
        }
    };

    const onSuggestionsClearRequested = () => {
        setState(prevState => {
            return {
                ...prevState,
                suggestions: []
            }
        });
    };

    const inputProps = {
        className: "form-control1 search-input",
        placeholder: 'جستجو در بازارها / برندها',
        value: state.value,
        onChange: onChange
    };

    const renderInputComponent = inputProps => (
        <div className="search-input-container">
            <i className="fas fa-search icon"></i>
            <input {...inputProps} />
        </div>
    )

    return (

        <div className={className ? `search-bar ${className}` : "search-bar"}>
            <InputGroup>
                {/* {state.loading && <ReactLoading type="spinningBubbles" color="#acacac"
                        height={40} width={40} className="search-loader" />} */}
                <Autosuggest
                    suggestions={state.suggestions}
                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProps}
                    renderInputComponent={renderInputComponent}
                    onSuggestionSelected={doSearch}
                    theme={{
                        container: 'search-box-container',
                        containerOpen: 'search-box-container',
                        input: 'form-control1 search-input',
                        inputOpen: 'form-control1 search-input',
                        inputFocused: 'form-control1 search-input',
                        suggestionsContainer: 'search-box-suggestions',
                        suggestionsContainerOpen: 'search-box-suggestions-open',
                        suggestionsList: 'search-box-suggestions-list',
                        suggestion: 'search-box-suggestions-suggestion',
                        suggestionFirst: 'react-autosuggest__suggestion--first',
                        suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
                        sectionContainer: 'react-autosuggest__section-container',
                        sectionContainerFirst: 'react-autosuggest__section-container--first',
                        sectionTitle: 'react-autosuggest__section-title'
                    }}
                />
            </InputGroup>
        </div>
    );
}

export default withRouter(HeaderSearch);
